import { render, staticRenderFns } from "./toobar.vue?vue&type=template&id=7a678d8a"
import script from "./toobar.vue?vue&type=script&lang=js"
export * from "./toobar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports